var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-end"},[_c('div',{ref:"viewport",staticClass:"overflow-hidden",style:({ 'max-height': _vm.maxHeight })},[_c('div',{ref:"content",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})]),(_vm.truncated)?_c('div',{staticClass:"text-xs"},[_vm._v("...")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }